import React from "react";
import { GradientSpan, H1, P2, P3 } from "../../components/theme/text/Headings";
import logoImg from "../../images/logo/v.png";

import {
  Blue,
  NeonGreen,
  OffWhite,
  Pink,
  White,
} from "../../components/theme/colors";

const PrivacyPolicy = () => {
  return (
    <div>
      <div
        style={{
          position: "relative",
          minHeight: "100vh",
          padding: "10vh 50px 100px 50px",
          backgroundColor: "#000",
          color: White,
        }}
      >
        {/* Centered logo */}
        <a className="text-decoration-none" href="https://www.vibecheckme.com">
          <img src={logoImg} alt="Vibe Check Logo" style={{ height: "50px" }} />
        </a>
        <H1 className="mt-10" color={White}>
          <GradientSpan $background={NeonGreen} $transitionBackground={Blue}>
            Privacy Policy
          </GradientSpan>{" "}
        </H1>
        <P2 color={White} className="mt-10">
          Effective Date: June 1st, 2025
        </P2>
        <P2 color={White} className="mt-30">
          At Vibe Check, we value your privacy and are committed to protecting
          your personal information. This Privacy Policy explains how we
          collect, use, and safeguard your data.
        </P2>

        <H1 className="mt-50">1. Information We Collect</H1>
        <P2 color={White} className="mt-10">
          We may collect the following information when you use the Service:
          <ul>
            <li>
              <strong>Personal Information:</strong> Phone number, email (if
              provided), quiz responses.
            </li>
            <li>
              <strong>Device Information:</strong> IP address, device type,
              operating system, browser type.
            </li>
            <li>
              <strong>Usage Data:</strong> App activity, crash reports,
              diagnostics, Firebase Analytics events.
            </li>
            <li>
              <strong>Location Data:</strong> Approximate location (city-level)
              derived from IP address.
            </li>
          </ul>
        </P2>

        <H1 className="mt-50">2. How We Use Your Data</H1>
        <P2 color={White} className="mt-10">
          We use collected data to:
          <ul>
            <li>Provide, operate, and maintain the Service</li>
            <li>Personalize user experience (e.g., compatibility scores)</li>
            <li>Monitor usage and improve app performance</li>
            <li>Communicate updates and changes to the Service</li>
            <li>Ensure compliance with legal obligations</li>
          </ul>
        </P2>

        <H1 className="mt-50">3. Legal Basis for Processing (GDPR)</H1>
        <P2 color={White} className="mt-10">
          For users in the European Economic Area (EEA), we process your
          personal data under the following legal bases:
          <ul>
            <li>Consent</li>
            <li>Performance of a contract</li>
            <li>Compliance with legal obligations</li>
            <li>
              Legitimate interests, provided they do not override your rights
            </li>
          </ul>
        </P2>

        <H1 className="mt-50">4. Third-Party Services</H1>
        <P2 color={White} className="mt-10">
          We use third-party services for core functionality:
          <ul>
            <li>
              Firebase Authentication & Firestore (user login, data storage)
            </li>
            <li>Firebase Analytics (usage tracking and diagnostics)</li>
            <li>Capacitor Plugins (native app functionality)</li>
            <li>RevenueCat (subscription management and billing)</li>
          </ul>
          These providers may process your data under their own privacy
          policies.
        </P2>

        <H1 className="mt-50">5. In-App Purchases & Subscriptions</H1>
        <P2 color={White} className="mt-10">
          Vibe Check offers optional in-app purchases for Pro features through
          auto-renewable subscriptions. When you make a purchase:
          <ul>
            <li>
              Payment processing is handled directly by Apple App Store. We do
              not collect or store your payment information.
            </li>
            <li>
              We use RevenueCat to manage subscription status and entitlements.
              RevenueCat receives transaction information from Apple/Google to
              verify your subscription.
            </li>
            <li>
              We store your subscription status (active/inactive) and
              entitlement information in our database to provide Pro features.
            </li>
            <li>
              You can manage or cancel your subscription at any time through
              your App Store or Google Play account settings.
            </li>
          </ul>
          For more information, see RevenueCat's Privacy Policy at
          https://www.revenuecat.com/privacy and your app store's terms.
        </P2>

        <H1 className="mt-50">6. Data Sharing</H1>
        <P2 color={White} className="mt-10">
          We do not sell or rent your personal data. We may share data:
          <ul>
            <li>With service providers necessary for app functionality</li>
            <li>To comply with legal obligations or enforce our Terms</li>
            <li>
              In connection with business transactions (e.g., mergers,
              acquisitions)
            </li>
          </ul>
        </P2>

        <H1 className="mt-50">7. Cookies & Tracking</H1>
        <P2 color={White} className="mt-10">
          We use cookies and similar technologies for analytics and improving
          the Service. By using Vibe Check, you consent to this tracking. For EU
          users, you can manage cookie preferences in your device settings.
        </P2>

        <H1 className="mt-50">8. Data Retention</H1>
        <P2 color={White} className="mt-10">
          We retain personal data only as long as necessary for the purposes
          outlined in this Policy. You may request deletion of your account and
          data at any time by emailing support@vibecheckme.com.
        </P2>

        <H1 className="mt-50">9. Your Privacy Rights</H1>
        <P2 color={White} className="mt-10">
          Depending on your location (e.g., EU, California), you may have the
          right to:
          <ul>
            <li>Access, correct, or delete your data</li>
            <li>Object to or restrict certain processing activities</li>
            <li>Request data portability</li>
            <li>Opt out of the sale of personal data (we do not sell data)</li>
          </ul>
          To exercise these rights, contact us at support@vibecheckme.com.
        </P2>

        <H1 className="mt-50">10. Children's Privacy</H1>
        <P2 color={White} className="mt-10">
          Vibe Check is not intended for children under 17 (or the age of
          majority in your jurisdiction). We do not knowingly collect personal
          data from children. If we discover such data, we will delete it
          promptly.
        </P2>

        <H1 className="mt-50">11. Data Security</H1>
        <P2 color={White} className="mt-10">
          We implement reasonable technical and organizational measures to
          protect your personal data. However, no system is completely secure,
          and we cannot guarantee absolute security.
        </P2>

        <H1 className="mt-50">12. Changes to This Policy</H1>
        <P2 color={White} className="mt-10">
          We may update this Privacy Policy from time to time. Updates will be
          posted in-app and on our website with a revised “Effective Date.”
        </P2>

        <H1 className="mt-50">13. Contact</H1>
        <P2 color={White} className="mt-10">
          For questions about this Privacy Policy, email us at
          support@vibecheckme.com.
        </P2>

        <div
          className="mt-100"
          style={{
            color: White,
            fontSize: "11px",
            textAlign: "center",
          }}
        >
          <P3 className="mb-20">
            Made by{" "}
            <GradientSpan $background={Blue} $transitionBackground={Pink}>
              Clickbait Labs, Inc.
            </GradientSpan>{" "}
          </P3>
          <a
            className="text-decoration-none mr-10"
            href="https://www.vibecheckme.com/terms-of-service"
            style={{
              color: OffWhite,
            }}
          >
            Terms of Service
          </a>{" "}
          <a
            className="text-decoration-none mr-10"
            href="https://www.vibecheckme.com/privacy-policy"
            style={{
              color: OffWhite,
            }}
          >
            Privacy Policy
          </a>{" "}
          <a
            className="text-decoration-none"
            href="https://www.vibecheckme.com/delete-my-data"
            style={{
              color: OffWhite,
            }}
          >
            Delete My Data
          </a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
